export function CollateralWhitelistPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Collateral Whitelist</h1>
      <p className="text-muted-foreground">Manage approved collateral assets.</p>
    </div>
  );
}
